import { useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  const navigate = useNavigate();

  return (
    <section id="category-nav" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            韩漫分类
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            按类型探索你感兴趣的韩漫
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {categories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => {
                navigate(`/category/${cat.slug}`);
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
              className="group flex flex-col items-center gap-3 p-6 rounded-lg bg-background-50 hover:bg-primary-50 transition-colors cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-primary-100 group-hover:bg-primary-200 transition-colors">
                <i className={`${cat.icon} text-xl md:text-2xl text-primary-600`}></i>
              </div>
              <div className="text-center">
                <h3 className="text-sm font-medium text-foreground-900 whitespace-nowrap">{cat.name}</h3>
                <p className="text-[11px] text-foreground-500 mt-1 line-clamp-2">{cat.description}</p>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}